export const PHONE_ADORNMENT = '+7';

export const TG_URL = 'https://t.me/cian_partner_help_bot';

export const FORM_DEFAULT_ERROR = 'Что-то пошло не так. Попробуйте снова или зайдите позже';
